export const NOS_BUSINESS_SIGN_UP_AUTOCOMPLETE_DEBOUNCE_TIMEOUT = 700;
export const NOS_BUSINESS_SIGN_UP_AUTOCOMPLETE_CHAR_LIMIT = 4;
export const NOS_BUSINESS_SIGN_UP_CAMPAIGN_CODE_PARAM = 'campaign';
export const NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_KEY = 'referral-source';
export const NOS_BUSINESS_SIGN_UP_REFERRAL_SOURCE_PARAM = 'source';
export const NOS_BUSINESS_SIGN_UP_REFERRAL_SET_EVENT = 'nos:referral:set';
